<template>
  <span class="logo-lg">
    <img src="@/assets/images/logo-aqua-1.png" alt height="50" />
  </span>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Logo'
})
</script>
